module.exports = __webpack_public_path__ + "static/media/marketing-digital.c2890f5f.svg";